import { render, staticRenderFns } from "./template.html?vue&type=template&id=7512b7af&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7512b7af')) {
      api.createRecord('7512b7af', component.options)
    } else {
      api.reload('7512b7af', component.options)
    }
    module.hot.accept("./template.html?vue&type=template&id=7512b7af&", function () {
      api.rerender('7512b7af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/views/common/object/component/form/elementLp1/radio/component.vue"
export default component.exports